import { render, staticRenderFns } from "./journey-email-step-widget.vue?vue&type=template&id=af99a63c&"
import script from "./journey-email-step-widget.vue?vue&type=script&lang=js&"
export * from "./journey-email-step-widget.vue?vue&type=script&lang=js&"
import style0 from "./journey-email-step-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports